module.exports = __webpack_public_path__ + "img/02.493fa0d5.jpg";